/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { styled, Typography } from '@mui/material';
import { FC } from 'react';

import Banner from './Banner';

import config from '@/config';
import { EnvBannerHeight } from '@/lib/constants/theme';

const EnvBannerRoot = styled(Banner)({
  position: 'sticky',
  top: 0,
  left: 0,
  right: 0,
  height: EnvBannerHeight,
  zIndex: 1100,
});

const EnvBanner: FC = () => {
  return (
    <EnvBannerRoot severity="warning" icon={false}>
      <Typography variant="caption">Local development</Typography>
      <Typography variant="caption" mx={1}>
        ·
      </Typography>
      <Typography variant="caption" fontWeight={600}>
        v{config.public.version}
      </Typography>
    </EnvBannerRoot>
  );
};

export default EnvBanner;
